import { render, staticRenderFns } from "./drugEdit.vue?vue&type=template&id=bdda1090&scoped=true&"
import script from "./drugEdit.vue?vue&type=script&lang=js&"
export * from "./drugEdit.vue?vue&type=script&lang=js&"
import style0 from "./drugEdit.vue?vue&type=style&index=0&id=bdda1090&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdda1090",
  null
  
)

export default component.exports